import React, { PropTypes, Component } from 'react';
import {
	NitroHeading,
	NitroPanel,
	NitroParagraph,
	NitroDrawer,
	NitroText,
	NitroTextField,
	NitroIcon
} from 'nitro-components';
import styled from 'styled-components';

import { getRule, removeLeadingZeros } from '../helper';

const EditPanelContent = styled.div`
	text-align: center;
`;

const DrawerContent = styled.div`
	padding: 20px;
`;

const InputElement = styled.section`
div {
	input {
  	color: ${props => props.theme.color.primary} !important;
		text-align: center !important;
		font-family: ${props => props.theme.font.bold} !important;
  }
}
	display: inline;
`;

class EditPortalSettings extends Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			parameters: [],
			invalidData: false,
			values: [],
			isDirty: false //to check if any of the fields are clicked
		};

		this.validateValues = this.validateValues.bind(this);
		this.onCancel = this.onCancel.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.editDetails !== this.props.editDetails) {
			let values = [];
			this.props.editDetails.map((item, index) => {
				values.push(item.Value);
			});
			this.setState({
				values: values
			});
		}
	}

	applyParam = () => {
		if (!this.state.invalidData && this.state.isDirty) {
			this.props.onSave(this.state.parameters);
			this.setState({
				isDirty: false
			});
		} else {
			this.props.onCancel();
		}
	};

	// On change check if the rules are satisfied for that particular field.
	// To be updated in case of different rules to be implemented in future-can be moved to redux-form if required
	validateValues = (e, index, id, rule) => {
		this.setState({
			isDirty: true
		});
		let parameters = this.state.parameters.splice(0);
		const inputValue = e.target.value;

		const values = this.state.values.splice(0);
		values[index] = e.target.value;
		this.setState({
			values: values
		});

		const regex = /^[0-9]+$/;

		//set character length of 200
		if(inputValue.length > 200) {
			this.setState({
				invalidData: true
			});
			return;
		}

		if (!regex.test(inputValue)) {
			this.setState({
				invalidData: true
			});
			return;
		}
		if (
			(rule && (rule.Min && parseInt(inputValue) < parseInt(rule.Min))) ||
			(rule && (rule.Max && parseInt(inputValue) > parseInt(rule.Max)))
		) {
			this.setState({
				invalidData: true
			});
			return;
		} else {
			this.setState({
				invalidData: false
			});
		}



		const modifiedParam = {
			ParameterId: id,
			Value: removeLeadingZeros(inputValue)
		};
		if (parameters.length === 0) {
			parameters.push(modifiedParam);
		} else {
			parameters.map((item, index) => {
				if (item.parameterId === e.target.parameterId) {
					item.Value = removeLeadingZeros(inputValue);
					return item;
				} else {
					parameters.push(modifiedParam);
				}
			});
		}
		this.setState({
			parameters: parameters
		});
	};

	onCancel = () => {
		let values = [];
		this.props.editDetails.map((item, index) => {
			values.push(removeLeadingZeros(item.Value));
		});
		this.setState({
			values: values
		});

		this.props.onCancel();
	};

	// generate the buttons for the panel
	getActions = () => {
		let actions = {};
		actions = {
			right: [
				{
					label: 'Cancel',
					action: this.onCancel
				},
				{
					label: 'Apply',
					variant: 'secondary',
					action: this.applyParam,
					disabled: this.state.invalidData
				}
			]
		};
		return actions;
	};

	render() {
		const { title, editDetails, isOpen } = this.props;
		return (
			<NitroDrawer
				isOpen={isOpen}
				close={this.onCancel}
				noPadding
				slideLeft
				staticFooter
				actions={this.getActions()}
			>
				<DrawerContent>
					<NitroHeading
						size="2"
						variant="secondary"
						label={`${title} parameters`}
					/>
					<EditPanelContent>
						{editDetails &&
							editDetails.map((item, index) => {
								return (
									<div key={index}>
										<NitroPanel
											key={index}
											marginBottom="15px"
											boxShadowLight
										>
											<NitroParagraph
												size="1"
												align="center"
											>
												{item.Description}
											</NitroParagraph>
											{item.DataType === 'currency' &&
												<NitroText
													size="1"
													variant="base3"
												>
													{item.Unit}
												</NitroText>}
											<InputElement>
												<NitroTextField
													hintText=""
													floatingLabelText=""
													value={
														this.state.values[
															index
														] || ''
													}
													name="parameter"
													onChange={e =>
														this.validateValues(
															e,
															index,
															item.ParameterId,
															item.Rule
														)}
													style={{
														width: '20%',
														fontSize: '24px'
													}}
												/>
											</InputElement>
											{item.DataType === 'number' &&
												<NitroText
													size="1"
													variant="base3"
												>
													{item.Unit}
												</NitroText>}

											<NitroParagraph
												size="4"
												align="center"
												variant="base3"
												noMargin
											>
												{getRule(
													item.Rule,
													item.Unit,
													item.DataType
												)}
											</NitroParagraph>

										</NitroPanel>
										<NitroParagraph
											size="4"
											align="center"
											variant="base3"
											noMargin
										>
											<NitroIcon
												name="info"
												variant="base3"
												size="14"
												right={6}
											/>
											{item.HelpText}
										</NitroParagraph>
									</div>
								);
							})}
					</EditPanelContent>
				</DrawerContent>
			</NitroDrawer>
		);
	}
}

EditPortalSettings.propTypes = {
	isOpen: PropTypes.bool,
	title: PropTypes.string,
	editDetails: PropTypes.array,
	onSave: PropTypes.func,
	onCancel: PropTypes.func
};

export default EditPortalSettings;



// WEBPACK FOOTER //
// ./src/features/notification/notification-settings/components/EditPortalSettings.js